(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/product-mapping/assets/javascripts/helpers/handlebarhelpers.js') >= 0) return;  svs.modules.push('/components/numbergames/product-mapping/assets/javascripts/helpers/handlebarhelpers.js');

'use strict';

var productMapping;
if (svs.isServer) {
  var path = require('path');
  productMapping = require(path.join(__dirname, '../', 'product-mapping.es6'));
  registerHelpers(require('hbs'));
} else {
  productMapping = svs.numbergames.productMapping;
  registerHelpers(Handlebars);
}
function registerHelpers(hbs) {
  hbs.registerHelper('brandingClass', function (productId) {
    return productMapping.getBrandingClass(productId);
  });
  hbs.registerHelper('isEurojackpot', function (productId, options) {
    return isProductHelper(productMapping.isEurojackpot(productId), options);
  });
  hbs.registerHelper('isKeno', function (productId, options) {
    return isProductHelper(productMapping.isKeno(productId), options);
  });
  hbs.registerHelper('isLotto', function (productId, options) {
    return isProductHelper(productMapping.isLotto(productId), options);
  });
  hbs.registerHelper('isJoker', function (productId, options) {
    return isProductHelper(productMapping.isJoker(productId), options);
  });
  hbs.registerHelper('isVikinglotto', function (productId, options) {
    return isProductHelper(productMapping.isVikinglotto(productId), options);
  });
  hbs.registerHelper('isDaySpecificId', function (product, options) {
    return isProductHelper(productMapping.isDaySpecificId(product), options);
  });
  hbs.registerHelper('isProductFamily', function (product, options) {
    return isProductHelper(productMapping.isProductFamily(product), options);
  });
  hbs.registerHelper('isOneOfProducts', function (productId) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }
    var options = params.pop();
    var isProduct = params.indexOf(productMapping.getProductId(productId)) > -1;
    return isProductHelper(isProduct, options);
  });
  hbs.registerHelper('numbergamesProductMapping', function (functionName) {
    for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      params[_key2 - 1] = arguments[_key2];
    }
    var options = params.pop();
    var result = '';
    var productMappingFunction = productMapping[functionName];
    if (productMappingFunction && typeof productMappingFunction === 'function') {
      result = productMappingFunction.apply(void 0, params);
    }
    if (result && options) {
      if (typeof options.fn === 'function') {
        return options.fn(options.data.root);
      } else if (typeof options.inverse === 'function') {
        return options.inverse(options.data.root);
      }
    }
    return result;
  });
}
function isProductHelper(isProduct, options) {
  if (options) {
    var data = options.data || {};
    if (isProduct) {
      if (typeof options.fn === 'function') {
        return options.fn(data.root);
      }
    } else if (typeof options.inverse === 'function') {
      return options.inverse(data.root);
    }
  }
  return isProduct;
}

 })(window);